<!--
 * @Author: your name
 * @Date: 2020-02-28 18:16:11
 * @LastEditTime: 2020-05-09 15:55:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\growth\index.vue
 -->
<template>
  <div class="growthIndex">
      <router-view></router-view>
  </div>
</template>

<style lang="less" scoped>
  .growthIndex{
    background: #fff;
    min-height: 100%;
  }
</style>


<script>
export default {
  name: "growthIndex",
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
      
  },
  created() {},
  methods: {
      
  }
};
</script>
